;(function (_, $) {
  $(document).ready(function(){
    const backToTopButton = $('#back-to-top');
    const progressCircle = $('.back-to-top-circle');

    $(window).on('scroll', function() {
      const scrollTop = $(window).scrollTop();
      const docHeight = $(document).height();
      const winHeight = $(window).height();

      const scrollPercent = scrollTop / (docHeight - winHeight);

      if (progressCircle.length) {
        const circumference = 283; // 2*π*r where r=45
        const offset = circumference - (scrollPercent * circumference);
        progressCircle.css('stroke-dashoffset', offset);
      }

      if (scrollTop > 300) {
        backToTopButton.addClass('visible');
      } else {
        backToTopButton.removeClass('visible');
      }
    });

    backToTopButton.on('click', function() {
      $('html, body').animate({
        scrollTop: 0
      }, 500);
      return false;
    });
  });
})(window, jQuery);
